import splide, { customSplide } from "../utils/splide";

const banner = document.getElementById("banner");
if (banner) {
  const bannerSplide = customSplide(banner, {
    type: "fade",
    rewind: true,
    perPage: 1,
    autoplay: true,
    fixedHeight: "623px",
    speed: 2000,
    lazyLoad: "sequential",
    pagination: true,
    arrows: banner.dataset.slides > 1 ? true : false,
    breakpoints: {
      1200: {
        pagination: true,
        arrows: false,
      },
      600: {
        fixedHeight: "unset",
      }
    },
  });
  bannerSplide.mount();
}

const consortium = document.getElementById("consortium-splide");
if (consortium) {
  const consortiumSplide = splide(consortium, {
    perPage: 6,
    breakpoints: {
      1200: {
        perPage: 4,
      },
      600: {
        perPage: 2,
        arrows: true,
        pagination: true,
      }
    }
  });
  consortiumSplide.mount()
}

const benefits = document.getElementById("benefits")
if (benefits) {
  const benefitsSplide = customSplide(benefits, {
    type: "loop",
    gap: "1em",
    perPage: 3,
    autoplay: true,
    speed: 2000,
    arrows: benefits.dataset.slides > 3 ? true : false,
    pagination: false,
    breakpoints: {
      1200: {
        perPage: 2,
        arrows: false,
        pagination: true,
      },
      600: {
        perPage: 1,
      },
    }
  })
  benefitsSplide.mount();
}

const faqArrow = document.querySelectorAll('.faq__card-question')
faqArrow.forEach(arrow => {
  arrow.addEventListener('click', () => {
    const upDownArrow = arrow.querySelector('i').classList.contains('fa-chevron-down') ? 'fa-chevron-up' : 'fa-chevron-down'
    arrow.querySelector('i').classList.toggle(upDownArrow)
  })
});

const deposition = document.getElementById('deposition')
const depositionSplide = splide(deposition, {
  perPage: 4,
  arrows: true,
  breakpoints: {
    1200: {
      perPage: 2,
    },
    600: {
      perPage: 1,
      arrows: true,
      pagination: true,
    }
  }
})
depositionSplide.mount()

const modal = () => {
  document.querySelector('.partner-form').classList.toggle('partner-modal--open')
  document.querySelector('.partner-form').classList.toggle('partner-modal--close')
  document.getElementById('close-modal').classList.toggle('fa-chevron-up')
  document.getElementById('close-modal').classList.toggle('fa-times')
}

document.getElementById('contact-modal').addEventListener('click', function () {
  modal()
})

const modalButton = document.getElementById('close-modal')
modalButton.addEventListener('click', function () {
  modal()
})